import React, { useState, useEffect } from 'react';
import { getFlat, getCounter } from '../../util/axios_utils';
import LoadingIndicator from '../../common/LoadingIndicator';
import NotFound from '../../common/NotFound';
import EventBus from "../../common/EventBus";
import ServerError from '../../common/ServerError';
import CheckAuthentication from '../../common/CheckAuthentication';
import { Select, Typography } from "antd";
import './LoginHome.css';
import Table from "../../components/Table";
const { Option } = Select;


const LoginHome = (props) => {
    // const { username } = useParams();
    const {
        isAuthenticated,
        currentUser
    } = props;
    const [flats, setFlats] = useState([]);
    const [address, setAddress] = useState('Выбор помещения');
    const [isLoading, setIsLoading] = useState(false);
    const [counters, setCounters] = useState([]);
    const [notFound, setNotFound] = useState(false);
    const [serverError, setServerError] = useState(false);
    const handleFlatSelect = (flatId) => {
        let flat = flats.find(item => item.flat === flatId);
        if (flatId !== null) {
            setIsLoading(true);
        }
        getCounter(flatId)
            .then(response => {
                setCounters(response.listCounter);
                setAddress(flat.address);
                setIsLoading(false);
            }).catch(error => {
                if (error.status === 404) {
                    setNotFound(true);
                    setIsLoading(false);
                } else if (error.status === 406) {
                    setServerError(true);
                    setIsLoading(false);
                    EventBus.dispatch("handleLogout");
                } else {
                    setServerError(true);
                    setIsLoading(false);
                }
            });
    }

    const columns = [
        {
            title: 'Ресурс',
            dataIndex: 'nameresource',
            key: 'nameresource',
            editable: false,
        },
        {
            title: 'Счетчик',
            dataIndex: 'namecounter',
            key: 'namecounter',
            editable: false,
        },
        {
            title: 'Заводской номер',
            dataIndex: 'Serialnumber',
            key: 'Serialnumber',
            editable: false,
        },
        {
            title: 'Дата поверки',
            dataIndex: 'datecheck',
            key: 'datecheck',
            editable: false,
            align: 'center'
        },
        {
            title: 'Предыдущие показания',
            dataIndex: 'value',
            key: 'value',
            editable: false,
            inputType: "number",
            align: 'center'
        },
        {
            title: 'Текущие показания',
            dataIndex: 'valuenew',
            key: 'valuenew',
            editable: true,
            inputType: "value",
            align: 'center'
        },
        { dataIndex: "edit", align: 'center', title: "Передать показания", editable: false }
    ];

    useEffect(() => {
        setIsLoading(true);
        getFlat()
            .then(response => {
                setFlats(response.listFlat);
                setIsLoading(false);
            }).catch(error => {
                if (error.status === 404) {
                    setNotFound(true);
                    setIsLoading(false);
                } else if (error.status === 406) {
                    setServerError(true);
                    setIsLoading(false);
                    EventBus.dispatch("handleLogout");
                } else {
                    setServerError(true);
                    setIsLoading(false);
                }
            });

    }, []);

    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (notFound) {
        return <NotFound />;
    }

    if (serverError) {
        return <ServerError />;
    }
    if (!isAuthenticated) {
        return <CheckAuthentication {...props} />
    }

    return (
        <div className="home-content">
            {
                currentUser.username ? (
                    <div>
                        <Typography.Title level={3}>Приборы учета</Typography.Title>
                        <Select
                            className="select"
                            defaultValue="Выбор помещения"
                            style={{ width: 500, marginBottom: 20 }}
                            onChange={handleFlatSelect}
                            value={address}
                        >
                            {flats.map((flat) => (
                                <Option key={flat.flat} value={flat.flat}>
                                    {flat.address}
                                </Option>
                            ))}
                        </Select>
                        <Table className="home-table" headers={columns} rows={counters} />
                    </div>
                ) : null
            }
        </div>
    );

}

export default LoginHome;